import { render, staticRenderFns } from "./SensorCategories.vue?vue&type=template&id=7fb24449"
import script from "./SensorCategories.vue?vue&type=script&lang=js"
export * from "./SensorCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports